import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "./ViewPost.css";
import like_icon from "../assets/Heart.png";
import PostComment from "./PostComment";
import CommentForm from "./ViewPostCommentForm.jsx";
import Header from "./Header";
import translations from "./translation.js";

const ViewPost = () => {
    const { PostID } = useParams();
    const [post, setPost] = useState({});
    const [comments, setComments] = useState([]);
    const [community, setCommunity] = useState("");
    const [Title, setTitle] = useState("");
    const [author, setAuthor] = useState("");
    const [likes, setLikes] = useState(0);
    const [fileurl, setFileurl] = useState("");
    const [message, setMessage] = useState("");
    const [reactions, setReactions] = useState([]);
    const currentLanguage = localStorage.getItem("selectedLanguage") || "en";

    const navigate = useNavigate();
    console.log("in");
    console.log("Post ID:", PostID);
    const loadPost = () => {
        // if the user is not logged in, we don't want to try loading posts, because it will just error out.
        if (sessionStorage.getItem("token")) {
            let url = process.env.REACT_APP_API_PATH + "/posts/" + PostID;
            // make an api request to fetch all the posts which are original posts (not comments/don't have a parentId)
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + sessionStorage.getItem("token"),
                },
            })
                .then((res) => res.json())
                .then((result) => {
                    console.log(result);
                    if (result) {
                        setPost(result);
                        setAuthor(result.author.attributes.username);
                        setLikes(result.reactions.length);
                        setFileurl(result.attributes.fileURL);
                        setReactions(result.reactions);
                        setCommunity(result.attributes.CommunityID);

                        console.log("Got Post");
                        console.log(result.attributes.likes);
                        console.log("author:", result.author.attributes.username);
                        console.log(result.attributes.title);
                        console.log("fileurl:", result.attributes.fileURL);

                        if (result.attributes.title === null || result.attributes.title === "") {
                            setTitle(translations[currentLanguage].view_title_error)
                        }
                        else {
                            setTitle(result.attributes.title);
                        }
                    }
                })
                .catch((err) => {
                    console.log("ERROR loading posts");
                });
        }
        else {
            const redirectURL = "/viewpost/" + PostID;
            sessionStorage.setItem('redirectURL', redirectURL);
            navigate("/");
        }
    };

    const showLike = () => {
        for (let i = 0; i < reactions.length; i++) {
            if (reactions[i].reactorID.toString() === sessionStorage.getItem("user")) {
                return (
                    <img
                        src={like_icon}
                        className="comment-icon liked"
                        onClick={(e) => tagPost("like", post.id)}
                        alt="Remove Like"
                    />
                );
            }
        }
        return (
            <img
                src={like_icon}
                className="comment-icon"
                onClick={(e) => tagPost("like", post.id)}
                alt="Remove Like"
            />
        )
    };
    const loadComments = () => {
        if (sessionStorage.getItem("token")) {
            let url = process.env.REACT_APP_API_PATH + "/posts?parentID=" + PostID;

            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + sessionStorage.getItem("token"),
                },
            })
                .then((res) => res.json())
                .then((result) => {
                    if (result) {
                        setComments(result[0]);
                        console.log("Comments:", result[0]);
                    }
                })
                .catch((err) => {
                    console.log("ERROR loading posts");
                });
        }
    };
    const tagPost = () => {
        //find the appropriate reaction to delete - namely, the one from the current user
        let userReaction = -1;
        post.reactions.forEach((reaction) => {
            if (reaction.reactorID === parseInt(sessionStorage.getItem("user"))) {
                userReaction = reaction.id;
            }
        });

        // if there is one, delete it.
        if (userReaction >= 0) {
            //make the api call to post
            fetch(
                process.env.REACT_APP_API_PATH + "/post-reactions/" + userReaction,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + sessionStorage.getItem("token"),
                    },
                }
            ).then(
                (result) => {
                    let newlikes = likes - 1;
                    updatelikes(newlikes);
                    setLikes(newlikes);
                    setMessage(translations[currentLanguage].remove_like);
                    setTimeout(setMessage, 3000, "");
                },
                (error) => {
                    alert("error!" + error);
                }
            );
        } else {
            //make the api call to post
            fetch(process.env.REACT_APP_API_PATH + "/post-reactions", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + sessionStorage.getItem("token"),
                },
                body: JSON.stringify({
                    reactorID: sessionStorage.getItem("user"),
                    postID: PostID,
                    name: "like",
                }),
            }).then(
                (result) => {
                    let newlikes = likes + 1;
                    updatelikes(newlikes);
                    setLikes(newlikes);
                    setMessage(translations[currentLanguage].like_post);
                    setTimeout(setMessage, 3000, "");
                },
                (error) => {
                    setMessage(translations[currentLanguage].like_post_error);
                    alert("error!" + error);
                }
            );
        }

    };
    const translateCommunity = (community) => {
        switch (community) {
          case "FPS":
            return translations[currentLanguage].community1;
          case "Battle-Royale":
            return translations[currentLanguage].community2;
          case "MOBA":
            return translations[currentLanguage].community3;
          case "Sandbox":
            return translations[currentLanguage].community4;
          case "Action-Adventure":
            return translations[currentLanguage].community5;
          default:
            return community;
        }
      };

    const updatelikes = async (newlikes) => {
        try {
            let url = process.env.REACT_APP_API_PATH + "/posts/" + PostID;
            const userResponse = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            console.log("in update likes");
            if (!userResponse.ok) {
                throw new Error('Failed to fetch user data');
            }

            const userData = await userResponse.json();
            const updatedAttributes = { ...userData.attributes, likes: newlikes };
            console.log("updatedAttributes:", updatedAttributes);
            console.log("likes:", newlikes);
            const patchResponse = await fetch(url, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    attributes: updatedAttributes,
                }),
            });

            if (!patchResponse.ok) {
                throw new Error('Failed to update switch status');
            }

            const result = await patchResponse.json();
            console.log('Switch status updated successfully:', result);
            loadPost();

        } catch (error) {
            console.error('Error updating switch status:', error);
            alert("Failed to update switch status");
        }
        loadPost();
    };

    useEffect(() => {
        // the first thing we do when the component is ready is load the posts.
        loadPost();
        loadComments();
    }, []);


    return (
        <div className="ViewPostPage_background">
            <Header />
            <div className="ViewPostPage_warpper">
                <div className="ViewPostPage_leftdiv">
                    <div className="ViewPostPage_leftdiv_content">
                        <div className="ViewPostPage_title">
                            <h1 className="ViewPost_h1">{Title}</h1>
                        </div>
                        <div className="ViewPostPage_author">
                            <h2>{translations[currentLanguage].author}: {author}</h2>
                        </div>
                        <div className="ViewPostPage_community">
                            <h4>{translations[currentLanguage].community}: {translateCommunity(community)}</h4>
                        </div>
                        <div className="ViewPostPage_Content">
                            <p>{post.content}</p>
                        </div>
                        <div className="ViewPostPage_file">
                            {fileurl && <img src={fileurl} alt="picture" />}
                        </div>
                        <div className="ViewPostPage_likes">
                            {showLike()}
                            <h3>{likes}</h3>
                            {message && (
                                <div className="ViewPost_Message">{message}</div>
                            )}
                        </div>
                    </div>
                    <div className="ViewPostPage_backbutton_container">
                        <Link to="/feed">
                            <button className="ViewPostPage_backbutton">{translations[currentLanguage].back}</button>
                        </Link>
                    </div>
                </div>
                <div className="ViewPostPage_rightdiv">
                    <div className="ViewPostPage_rightdiv_content">
                        <div className="ViewPostPage_CommentForm">
                            <CommentForm
                                parent={PostID}
                                loadPosts={loadPost}
                                loadComments={loadComments}
                            />
                        </div>
                        <div className="ViewPostPage_Comments">
                            <h2>{translations[currentLanguage].comments}:</h2>
                            <div className="ViewPostPage_CommentsList">
                                {comments.map((comment) => (
                                    <div className="ViewPostPage_Comment">
                                        {console.log("comment:", comment)}
                                        {console.log("comment.id", comment.id)}
                                        <PostComment key={comment.id} commentAuthor={comment.author.attributes.username} postComment={comment} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewPost;